export default "__VITE_ASSET__6c3ae5fd__"